/* eslint-disable */
import validate from 'validate.js'
import api from '../../../api/recipe'
import router from '../../../router'


const actions = {
    async getFieldOptions({ commit }, optionFor) {
        const response = await api.getOptions()
        const finalOptions = {}
        response.data.forEach(option => {
            if (typeof finalOptions[option.option_for] == 'undefined') {
                finalOptions[option.option_for] = []
            }
            finalOptions[option.option_for].push(option)
        })
        commit('setFieldOptions', finalOptions)
    },
    async getUnits({ commit }) {
        const response = await api.getUnits()
        const units = response.data.results
        commit('setUnits', units)
    },

    async getUnit({ commit }, id) {
        const response = await api.getUnit(id)
        return response.data
    },
    async getIngredients({ commit }) {
        const response = await api.getIngredients()
        const ingredients = response.data.results
        commit('setIngredients', ingredients)
    },
    async getIngredient({ commit }, id) {
        const response = await api.getIngredient(id)
        commit('setCurrentIngredient', response.data)
    },
    async getIngredientRecipe({ commit }, id) {
        const response = await api.getIngredient(id)
        return response.data
    },
    async getCategories({ commit }) {
        const response = await api.getCategories()
        const categories = response.data
        commit('setCategories', categories)
    },
    async getRecipes({ commit }, args) {
        console.log(args)
        const response = await api.getRecipes(args)
        console.log(response.data)
        commit('setRecipeList', response.data)
    },
    async getRecipesOptions({ commit }) {
        const response = await api.getRecipesOptions()
        commit('setRecipesOptions', response.data)
    },

    async getRecipe({ commit, state }, id) {
        const response = await api.getRecipe(id)
        commit('setRecipe', response.data)
    },
    async createRecipe({ dispatch, getters, commit }, payload) {
        const validationRules = getters['recipeValidationRules']
        const validationResult = validate(payload, validationRules)
        if (validationResult) {
            commit('setRecipeValidation', validationResult)
            return false
        } else {
            commit('setEmptyRecipeValidation')
        }

        try {
            const response = await api.createRecipe(payload)
            commit('setRecipe', response.data)
            router.push(`/recipe/${response.data.id}`)
        }
        catch (e) {
            const serverValidationResult = {}
            Object.keys(e.response.data).forEach(key => {
                serverValidationResult[key] = e.response.data[key].join(' ')
            })
            commit('setRecipeValidation', serverValidationResult)
            return serverValidationResult
        }
    },

    async updateRecipe({ state, getters, commit }, id) {
        const validationRules = getters['recipeValidationRules']
        const validationResult = validate(state.currentRecipe, validationRules)
        console.log(validationResult)
        if (validationResult) {
            commit('setRecipeValidation', validationResult)
            return false
        } else {
            commit('setEmptyRecipeValidation')
        }
        console.log(state.currentRecipe)
        const response = await api.updateRecipe(id, state.currentRecipe)
        // commit('setRecipe', response.data)
    },
    async updateRecipe({ commit, state, getters }, id) {
        const response = await api.updateRecipe(id, state.currentRecipe)
        // commit('setRecipe', response.data)
    },
    openIngredientsModal({ commit }) {
        commit('setShowIngredientsModal', true)
    },
    closeIngredientsModal({ commit }) {
        commit('setShowIngredientsModal', false)
    },
    setShowIngredientsModal({ commit }, payload) {
        commit('setShowIngredientsModal', payload)
    },
    async createIngredient({ dispatch, state }, payload) {
        const response = await api.createIngredient(payload)
        dispatch('getIngredients', state.currentRecipe.id)
        return response.data;
    },
    async updateIngredient({ dispatch, state }, payload) {
        const response = await api.updateIngredient(payload)
        dispatch('getIngredients', state.currentRecipe.id)
        dispatch('getRecipe', state.currentRecipe.id)
        return response.data
    },
    async createIngredientGroup({ dispatch, commit, state }, data) {
        const groupObj = {
            name: data.g_name,
            recipe: data.group.recipe,
            position: data.group.position,
        }
        const response = await api.createIngredientGroup(groupObj)
        dispatch('getRecipe', state.currentRecipe.id)
        return response.data.id
        // commit('updateRecipeIngredientGroup', {
        //     groupId: data.group.id,
        //     data: response.data
        // })
    },
    async updateIngredientGroup({ dispatch, state }, data) {
        const groupObj = {
            id: data.id,
            name: data.g_name,
            recipe: data.group.recipe,
            position: data.group.position,
        }
        await api.updateIngredientGroup(groupObj)
    },
    async deleteIngredientGroup({ dispatch, state }, id) {
        await api.deleteIngredientGroup(id)
        dispatch('getRecipe', state.currentRecipe.id)
    },
    async createIngredientGroupItem({ dispatch, state, commit }, data) {
        const response = await api.createIngredientGroupItem(data)
        return response.data
    },
    async updateIngredientGroupItem({ dispatch, state }, data) {
        await api.updateIngredientGroupItem(data)
    },


    async createIngredientGroupItemOnModal({ dispatch, state, commit }, data) {
        const response = await api.createIngredientGroupItem(data)
        dispatch('getRecipe', state.currentRecipe.id)
        return response.data
    },

    async updateIngredientGroupItemOnModal({ dispatch, state }, payload) {
        await api.updateIngredientGroupItem(payload)
    },

    async deleteIngredientGroupItem({ dispatch, state }, id) {
        await api.deleteIngredientGroupItem(id)
        dispatch('getRecipe', state.currentRecipe.id)
    },
    async getIngredientItemNumericQuantity({ commit }) {
        const response = await api.getIngredientItemNumericQuantity()
        commit('setIngredientItemNumericQuantity', response.data.results)
    },
    async createIngredientItemNumericQuantity({ dispatch }, payload) {
        const response = await api.createIngredientItemNumericQuantity(payload)
        dispatch('getIngredientItemNumericQuantity')
        return response.data
    },

    async patchIngredientGroupItem({ commit }, payload) {
        await api.patchIngredientGroupItem(payload.id, payload)
    },

    async createMethodGroup({ dispatch, state, commit }, data) {
        const groupObj = {
            name: data.g_name,
            recipe: data.group.recipe,
            position: data.group.position,
        }
        const response = await api.createMethodGroup(groupObj)
        dispatch('getRecipe', state.currentRecipe.id)
        return response.data.id
        // commit('updateRecipeMethodGroup', {
        //     groupId: data.group.id,
        //     data: response.data
        // })
    },
    async updateMethodGroup({ dispatch, state }, data) {
        const groupObj = {
            id: data.id,
            name: data.g_name,
            recipe: data.group.recipe,
            position: data.group.position,
        }
        await api.updateMethodGroup(groupObj)
    },

    async deleteMethodGroup({ dispatch, state }, id) {
        await api.deleteMethodGroup(id)
        dispatch('getRecipe', state.currentRecipe.id)
    },

    async createMethodGroupInstruction({ commit, state }, data) {
        const response = await api.createMethodGroupInstruction(data)
        return response.data.id
        // commit('updateRecipeMethodGroupInstruction', {
        //     instructionId: data.id,
        //     newInstruction: response.data
        // })
    },
    async updateMethodGroupInstruction({ dispatch, state }, data) {
        await api.updateMethodGroupInstruction(data)

    },
    async deleteMethodGroupInstruction({ dispatch, state }, id) {
        await api.deleteMethodGroupInstruction(id)
        dispatch('getRecipe', state.currentRecipe.id)
    },
    async patchMethodGroupInstruction({ commit }, payload) {
        await api.patchMethodGroupInstruction(payload.id, payload)
    },

    async getDietaryOptions({ commit },) {
        const response = await api.getDietaryOptions()
        commit('setDietaryOptions', response.data)
    },

    async getUsers({ commit },) {
        const response = await api.getUsers()
        commit('setUsersOptions', response.data)
    },



}
export default actions
